import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * BackToTop — floating pill button that appears after the user scrolls
 * past ~400px. Clicking smooth-scrolls the page back to the top.
 */
const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="Volver arriba"
      data-testid="back-to-top-btn"
      className={`cn-back-to-top ${visible ? "is-visible" : ""}`}
    >
      <ArrowUp size={20} strokeWidth={2.4} aria-hidden="true" />
    </button>
  );
};

export default BackToTop;
